<template>
  <div class="upload">
    <h1>Upload</h1>

    <div class="container">
      <div class="large-12 medium-12 small-12 cell">
        <label>File
          <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
        </label>
          <button v-on:click="submitFile()">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>

import config from '../config'

export default {
  name: 'Upload',
  data () {
    return {
      file: ''
    }
  },
  methods: {
    submitFile(){
      const token = localStorage.getItem('token');
        let formData = new FormData();

        formData.append('file', this.file);

        this.axios.post(config.api + '/upload',
            formData,
            {
            headers: {
                'Content-Type': 'multipart/form-data',
                'authorization': token
            }
          }
        )
    },
    handleFileUpload(){
      this.file = this.$refs.file.files[0];
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Upload.vue